import { useEffect, useRef } from 'react';
import { subscribePurchaseEvents } from '../utils/purchaseEventsHub';

const usePurchaseEvents = (branchId, onEvent, options = {}) => {
  const { enabled = true } = options;
  const handlerRef = useRef(onEvent);

  useEffect(() => {
    handlerRef.current = onEvent;
  }, [onEvent]);

  useEffect(() => {
    if (!enabled || !branchId) return;

    const unsubscribe = subscribePurchaseEvents((data) => {
      if (handlerRef.current) {
        handlerRef.current(data);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [branchId, enabled]);
};

export default usePurchaseEvents;
